import { appUrl } from 'utils/wrappers';

import PageableBase from 'app/collections/pageable_base';
import Event from 'app/models/event';

export default PageableBase.extend({
  model: Event,
  key: 'events',
  url: appUrl('events'),

  initialize(models, { apiModeSelection, dateRange, statusSelection, descriptionSelection }) {
    this.apiModeSelection = apiModeSelection;
    this.dateRange = dateRange;
    this.statusSelection = statusSelection;
    this.descriptionSelection = descriptionSelection;

    this.listenTo(this.apiModeSelection, 'change', this.resetToFirstPage);
    this.listenTo(this.dateRange, 'change', this.resetToFirstPage);
    this.listenTo(this.statusSelection, 'change', this.resetToFirstPage);
    this.listenTo(this.descriptionSelection, 'change', this.resetToFirstPage);
  },

  paramsForFetch() {
    return {
      ...this.apiModeSelection.getParams(),
      ...this.dateRange.getParams(),
      ...this.statusSelection.getParams(),
      ...this.descriptionSelection.getParams(),
    };
  },
});



// WEBPACK FOOTER //
// ./app/collections/events.js